import { render, staticRenderFns } from "./PermitsAddUpdate.vue?vue&type=template&id=44f53597"
import script from "./PermitsAddUpdate.vue?vue&type=script&lang=js"
export * from "./PermitsAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports